export default class UrlHandler {
  constructor() {
    this.urlParams = new URLSearchParams(window.location.search)
  }

  /**
   * Get url parameters
   * @param {string} parameter name of the parameter
   * @param {string} type type of the parameter
   * @return {string|array}
   */
  getParameter(parameter, type = 'array') {
    if (parameter && this.urlParams.has(parameter)) {
      return type === 'array' ? this.urlParams.get(parameter).split(',') : this.urlParams.get(parameter);
    }
    return type === 'array' ? [] : '';
  }

  /**
   * Set url parameters
   * @param {string} parameter Name of the parameter
   * @param {any} data Parameter data
   */
  setParameter(parameter, data = null) {
    if (parameter) {
      if (data && Array.isArray(data)) {
        data = data.filter(Boolean).length > 0 ? data : null;
      }
      if (data === '' || !data) {
        this.urlParams.delete(parameter);
      } else {
        this.urlParams.set(parameter, data);
        data = Array.isArray(data) ? data.filter(Boolean) : data;
      }
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    }
  }

  /**
   * Remove parameter on item in array of parameter
   * @param {string} parameter name of parameter
   * @param {string} data remove this data from array
   */
  removeParameter(parameter, data = null) {
    if (parameter) {
      if (data === '' || !data) {
        this.urlParams.delete(parameter);
        return;
      }
      if (data) {
        if (Array.isArray(this.getParameter(parameter)) && this.getParameter(parameter).length > 1) {
          this.setParameter(parameter, this.getParameter(parameter).filter(item => item !== data));
        } else {
          this.setParameter(parameter, null);
        }
      }
    }
  }

  /**
   * Empty parameters
   */
  emptyParameters() {
    window.history.replaceState({}, '', `${location.pathname}`);
    this.urlParams = new URLSearchParams(window.location.search);
  }

  /**
   * Attach handler for url update
   * @param {array|string} elements element of elements to be checked for changes and update url
   * @param {boolean} forceArray force data to be always array
   */
  addHandler(elements, forceArray = false) {
    if (!Array.isArray(elements)) {
      elements = [elements];
    }
    elements.forEach((el) => {
      let paramData = this.getParameter(el.name);
      if (el.type === 'checkbox') {
        el.checked = paramData.includes(el.value);
      } else {
        if (el.tagName === 'SELECT') {
          if (paramData.length > 0) {
            el.value = Array.isArray(paramData) ? paramData[0] : paramData;
          }
        } else {
          el.value = paramData;
        }
      }
      el.addEventListener('change', () => {
        paramData = this.getParameter(el.name);
        // If there is more inputs than 1 (then handle array)
        if (elements.length > 1 || forceArray) {
          if (paramData.includes(el.value) || (el.type === 'checkbox' && el.checked === false)) {
            // Delete from array
            this.setParameter(el.name, paramData.filter(item => item !== el.value))
          } else {
            // Add to array
            if (paramData.length > 0) {
              this.setParameter(el.name, paramData.concat([el.value]));
            } else {
              this.setParameter(el.name, el.value);
            }
          }
        } else {
          this.setParameter(el.name, el.value);
        }
      });
    });
  }
}
